import { object, string } from 'yup'

import { validateField, validateValues } from 'shared/utils/form'
import { passwordRegex } from 'shared/utils/validators'

import { ResetPasswordPayload } from '../api/auth'

// REGISTRATION
export const resetPasswordSchema = object().shape({
  email: string()
    .required('Email jest wymagany')
    .email('Niepoprawny adres email')
})

export const validateResetField = (values: ResetPasswordPayload) =>
  validateField(resetPasswordSchema, values)
export const validateResetValues = validateValues(resetPasswordSchema)

export const newPasswordSchema = object().shape({
  password: string()
    .required('Hasło jest wymagane')
    .matches(passwordRegex, 'Niepoprawny format hasła'),
  passwordConfirmation: string().test(
    'password-match',
    'Podane hasła muszą być identyczne',
    function (value) {
      const parent = this.parent as { password: string }

      const password = parent.password

      return password === value
    }
  )
})

interface NewPasswordValidationPayload {
  password: string
  passwordConfirmation: string
}

export const validateNewPassword = (values: NewPasswordValidationPayload) =>
  validateField(newPasswordSchema, values)
export const validateNewPasswordValues = validateValues(newPasswordSchema)
